// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  scrollContainer: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: `0 ${theme.other.spacing._16}px`,

    '&::-webkit-scrollbar': {
      width: '6px',
    },

    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },

    '&::-webkit-scrollbar-thumb': {
      background: theme.colors.gray[4],
      borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '3px',
    },

    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.colors.gray[5],
    },
  },

  postItem: {
    marginBottom: theme.other.spacing._12, // 12px spacing between posts to match Figma
    '&:first-of-type': {
      marginTop: theme.other.spacing._8,
    },
    '&:last-of-type': {
      marginBottom: theme.other.spacing._8,
    },
  },

  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${theme.other.spacing._8}px 0`,
    color: theme.colors.gray2[3], // #909296
    fontSize: '12px',
  },
}));
